export default "__VITE_ASSET__DmBvoo7b__"